import { combineReducers } from "redux";
import heliocores from "./heliocores/reducer";

const heliocoreReducer = combineReducers({
  heliocores
});

export default heliocoreReducer;
